import { useEffect } from 'react';

import { useLocation } from 'react-router';

import { useI18n } from '@change-corgi/core/react/i18n';

import type { StarterDashboardPageData } from 'src/app/pages/starterDashboard/pageContext';
import { useStarterDashboardBannerState } from 'src/app/pages/starterDashboard/pageContext';

const SIX_HOURS = 6 * 60 * 60 * 1000;

type Promotion = NonNullable<StarterDashboardPageData['petition']['freePromotions']>[number];
export function useFreePromotionStatus(promotion: Promotion | undefined) {
	const { actions } = useStarterDashboardBannerState();
	const location = useLocation();
	const { translate } = useI18n();
	useEffect(() => {
		// ALERTS: comment this line
		if (!promotion) return;

		// ALERTS: comment this line
		const fulfillmentTime = promotion.fulfilledAt ? new Date(promotion.fulfilledAt).getTime() : 0;
		const currentTime = Date.now();

		// ALERTS: comment this line
		if (promotion.fulfilledAt && currentTime - fulfillmentTime > SIX_HOURS) return;

		actions.addBanner({
			message: translate('corgi.petition.starter_dashboard.free_promotion_banner.start.title'),
			primaryAction: {
				to: `${location.pathname + location.search}#petition-insights-title`,
				forceMode: 'external',
				text: translate('corgi.petition.starter_dashboard.free_promotion_banner.start.button'),
				type: 'link' as const,
			},
			severity: 'success' as const,
			dismissable: true,
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
}
